import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import booleanHelper from '../Helpers/booleanHelper';
import dateTimeHelper from '../Helpers/datetimeHelper';
import moneyHelper from '../Helpers/moneyHelper';
import FeeTypesEnum from '../Enums/FeeTypesEnum';
import FreelancerUserAdmin from '../Contents/FreelancerInvoicing/FreelancerUserAdmin/FreelancerUserAdmin';
import Link from '../Elements/link';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import GeneralEntryLogFigma from '../Elements/GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from '../Elements/CommentsEntryLogDescription';
import FaIcon from '../Elements/FaIcon';
import LogComponent from '../Elements/LogComponent';
import LineItemTypeEnum from '../Enums/LineItemTypeEnum';
import FreelancerInvoiceAdmin from '../Contents/FreelancerInvoicing/FreelancerInvoices/FreelancerInvoiceAdmin';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import FreelancerFeeHelper from '../Helpers/ModelHelpers/FreelancerFeeHelper';

class FreelancerLineItem {
  constructor(item) {
    if (item === undefined) {
      this.FreelancerLineItemId = null;
      this.FreelancerUserId = '';
      this.FeeType = '';
      this.LineItemType = LineItemTypeEnum.Addition;
      this.ClientId = '';
      this.SurveyId = '';
      this.TpSurveyId = '';
      this.ThirdPartySource = '';
      this.WaveId = '';
      this.TpWaveId = '';
      this.ApplyDate = new Date();
      this.Fee = 0;
      this.ClientName = '';
      this.ClientSassieId = '';
      this.ThirdPartyClientId = '';
      this.FreelancerUserName = '';
      this.FreelancerUserCurrencyCode = '';
      this.FreelancerUserOfficeName = '';
      this.SurveyName = '';
      this.SurveySassieId = '';
      this.TpSurveyThirdPartySurveyName = '';
      this.TpSurveyThirdPartySurveyId = '';
      this.WaveName = '';
      this.TpWaveSassieId = '';
      this.TpWaveThirdPartyWaveName = '';
      this.TpWaveThirdPartyWaveId = '';
      this.FreelancerUserIsKAM = '';
      this.FreelancerUserIsRM = '';
      this.FreelancerUserIsDQ = '';
      this.FreelancerUserIsBD = '';
      this.FreelancerUserIsBI = '';
      this.FreelancerUserIsHR = '';
      this.FreelancerUserIsIT = '';
      this.FreelancerUserIsMarketing = '';
      this.FreelancerUserIsFinance = '';
      this.FreelancerUserIsFieldworkPartner = '';
      this.IsActive = true;
      this.LastComment = '';
      this.FreelancerInvoiceId = '';
      this.Status = '';
      this.TimesheetEntryLength = '';
      this.LoggedTime = '';
      this.Occurence = '';
      this.TimesheetEntryId = '';
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.FreelancerLineItemId = item.freelancerLineItemId;
    this.FreelancerUserId = item.freelancerUserId;
    this.FeeType = item.feeType;
    this.LineItemType = item.lineItemType;
    this.ClientId = item.clientId;
    this.SurveyId = item.surveyId;
    this.TpSurveyId = item.tpSurveyId;
    this.ThirdPartySource = item.thirdPartySource;
    this.WaveId = item.waveId;
    this.TpWaveId = item.tpWaveId;
    this.ApplyDate = item.applyDate;
    this.Fee = item.fee;
    this.ClientName = item.clientName;
    this.ClientSassieId = item.clientSassieId;
    this.ThirdPartyClientId = item.thirdPartyClientId;
    this.FreelancerUserName = item.freelancerUserName;
    this.FreelancerUserCurrencyCode = item.freelancerUserCurrencyCode;
    this.FreelancerUserOfficeName = item.freelancerUserOfficeName;
    this.SurveyName = item.surveyName;
    this.SurveySassieId = item.surveySassieId;
    this.TpSurveyThirdPartySurveyName = item.tpSurveyThirdPartySurveyName;
    this.TpSurveyThirdPartySurveyId = item.tpSurveyThirdPartySurveyId;
    this.WaveName = item.waveName;
    this.WaveSasseId = item.waveSasseId;
    this.TpWaveThirdPartyWaveName = item.tpWaveThirdPartyWaveName;
    this.TpWaveThirdPartyWaveId = item.tpWaveThirdPartyWaveId;
    this.FreelancerUserIsKAM = item.freelancerUserIsKAM;
    this.FreelancerUserIsRM = item.freelancerUserIsRM;
    this.FreelancerUserIsDQ = item.freelancerUserIsDQ;
    this.FreelancerUserIsBD = item.freelancerUserIsBD;
    this.FreelancerUserIsBI = item.freelancerUserIsBI;
    this.FreelancerUserIsHR = item.freelancerUserIsHR;
    this.FreelancerUserIsIT = item.freelancerUserIsIT;
    this.FreelancerUserIsMarketing = item.freelancerUserIsMarketing;
    this.FreelancerUserIsFinance = item.freelancerUserIsFinance;
    this.FreelancerUserIsFieldworkPartner = item.freelancerUserIsFieldworkPartner;
    this.IsActive = item.isActive;
    this.TimesheetEntryId = item.timesheetEntryId;
    this.TimesheetEntryStartDate = item.timesheetEntryStartDate;
    this.TimesheetEntryEndDate = item.timesheetEntryEndDate;
    this.TimesheetEntryStartTime = item.timesheetEntryStartTime;
    this.TimesheetEntryEndTime = item.timesheetEntryEndTime;
    this.LastComment = item.lastComment;
    this.FreelancerInvoiceId = item.freelancerInvoiceId;
    this.Status = item.status;
    this.TimesheetEntryLength = item.timesheetEntryLength;
    this.LoggedTime = item.loggedTime;
    this.Occurence = item.occurence;
    this.Selected = false;
    this.TimesheetClientNameAndId = item.timesheetClientNameAndId;
    this.TimesheetOppNameAndId = item.timesheetOppNameAndId;
    this.TimesheetLeadNameAndId = item.timesheetLeadNameAndId;
    FreelancerLineItem.ConvertEntryDatesToLocal(this);
  }

  static ConvertEntryDatesToLocal(item) {
    if (!item.TimesheetEntryId) return;
    const localUTCOffsetInMinutes = new Date().getTimezoneOffset();

    // Combine startdate and time to one date object (date.month is zero based so we need to subtrack 1)
    let combinedStartDate = new Date(
      item.TimesheetEntryStartDate.split('-')[0],
      item.TimesheetEntryStartDate.split('-')[1] - 1,
      item.TimesheetEntryStartDate.split('-')[2],
      item.TimesheetEntryStartTime.split(':')[0],
      item.TimesheetEntryStartTime.split(':')[1],
      0,
      0
    );

    combinedStartDate = this.dateAdd(combinedStartDate, 'minute', -1 * localUTCOffsetInMinutes);

    item.TimesheetEntryStartDate = dateTimeHelper.getFormattedDate(combinedStartDate, '-');
    item.TimesheetEntryStartTime = (
      combinedStartDate.getHours().toString().length === 1
        ? '0'.concat(combinedStartDate.getHours())
        : combinedStartDate.getHours()
    )
      .toString()
      .concat(
        `:${
          combinedStartDate.getMinutes().toString().length === 1
            ? '0'.concat(combinedStartDate.getMinutes())
            : combinedStartDate.getMinutes()
        }`
      );

    let combinedEndDate = new Date(
      item.TimesheetEntryEndDate.split('-')[0],
      item.TimesheetEntryEndDate.split('-')[1] - 1,
      item.TimesheetEntryEndDate.split('-')[2],
      item.TimesheetEntryEndTime.split(':')[0],
      item.TimesheetEntryEndTime.split(':')[1],
      0,
      0
    );

    combinedEndDate = this.dateAdd(combinedEndDate, 'minute', -1 * localUTCOffsetInMinutes);

    item.endDate = dateTimeHelper.getFormattedDate(combinedEndDate, '-');
    item.TimesheetEntryEndTime = (
      combinedEndDate.getHours().toString().length === 1
        ? '0'.concat(combinedEndDate.getHours())
        : combinedEndDate.getHours()
    )
      .toString()
      .concat(
        `:${
          combinedEndDate.getMinutes().toString().length === 1
            ? '0'.concat(combinedEndDate.getMinutes())
            : combinedEndDate.getMinutes()
        }`
      );

    return item;
  }

  static dateAdd(date, interval, units) {
    if (!(date instanceof Date)) return undefined;
    let ret = new Date(date); //don't change original date
    const checkRollover = () => {
      if (ret.getDate() !== date.getDate()) ret.setDate(0);
    };
    switch (String(interval).toLowerCase()) {
      case 'year':
        ret.setFullYear(ret.getFullYear() + units);
        checkRollover();
        break;
      case 'quarter':
        ret.setMonth(ret.getMonth() + 3 * units);
        checkRollover();
        break;
      case 'month':
        ret.setMonth(ret.getMonth() + units);
        checkRollover();
        break;
      case 'week':
        ret.setDate(ret.getDate() + 7 * units);
        break;
      case 'day':
        ret.setDate(ret.getDate() + units);
        break;
      case 'hour':
        ret.setTime(ret.getTime() + units * 3600000);
        break;
      case 'minute':
        ret.setTime(ret.getTime() + units * 60000);
        break;
      case 'second':
        ret.setTime(ret.getTime() + units * 1000);
        break;
      default:
        ret = undefined;
        break;
    }
    return ret;
  }

  static NameOfTheIdField() {
    return 'FreelancerLineItemId';
  }
  static nameOfTheItemDetailList(item) {
    return `Vendor Line Item (${item.FreelancerLineItemId})`;
  }

  static MoneyFields = ['Fee'];

  static Currency() {
    return 'FreelancerUserCurrencyCode';
  }

  static MoneyFieldsSecondary = [''];

  static CurrencySecondary() {
    return 'FreelancerUserCurrencyCode';
  }

  static DateFields = ['ApplyDate'];

  static BoolFields = ['FreelancerUserIsKAM', 'FreelancerUserIsRM', 'FreelancerUserIsDQ'];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'FeeType', label: 'Fee Type', className: 'text-left' },
        { name: 'LineItemType', label: 'Line Item Type', className: 'text-left' },
        { name: 'ApplyDate', label: 'Application Date' },
        { name: FreelancerLineItem.getClientName, label: 'Client (Bravo ID)', className: 'text-left' },
        { name: FreelancerLineItem.getSurveyName, label: 'Survey (ID)', className: 'text-left' },
        { name: FreelancerLineItem.getWaveName, label: 'Wave (ID)', className: 'text-left' },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.Fee, item.FreelancerUserCurrencyCode),
          label: 'Fee',
          className: 'text-right',
        },
        { name: 'ThirdPartySource', label: 'Third Party Source', className: 'text-left' },
        { name: FreelancerLineItem.getTpSurveyName, label: 'TP Survey (ID)', className: 'text-left' },
        // { name: FreelancerLineItem.getTpWaveName, label: 'TP Wave (ID)', className: 'text-left' },
        { name: 'FreelancerInvoiceId', label: 'Freelancer Invoice Id' },
      ],
    },
    {
      tabName: 'RelatedTimesheetEntry',
      tabLabel: 'Related Activity Tracker Entry',
      icon: 'fa-solid fa-calendar-days',
      data: [
        { name: 'TimesheetEntryId', label: 'Activity Tracker Id' },
        {},
        {},
        { name: 'TimesheetEntryLength', label: 'Activity Tracker Length Total (hour)' },
        { name: 'Occurence', label: 'Activity Tracker Length (days)' },
        { name: 'LoggedTime', label: 'Activity Tracker Length per Day (hour)' },
        { name: 'TimesheetEntryStartDate', label: 'Start Date' },
        { name: 'TimesheetEntryStartTime', label: 'Start Time' },
        {},
        { name: 'TimesheetEntryEndDate', label: 'End Date' },
        { name: 'TimesheetEntryEndTime', label: 'End Time' },
        {},
        { name: 'TimesheetClientNameAndId', label: 'Client' },
        { name: 'TimesheetOppNameAndId', label: 'Opportunity' },
        { name: 'TimesheetLeadNameAndId', label: 'Lead' },
      ],
    },
    {
      tabName: 'Comments',
      tabLabel: 'Comments',
      icon: 'fa-solid fa-comment',
      data: [
        { name: FreelancerLineItem.getCommentsContent, label: 'Comments', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'Log',
      tabLabel: 'Log',
      icon: 'fa-solid fa-stream',
      data: [{ name: FreelancerLineItem.getLogContent, label: 'Log', width: TabListTableCellWidthEnum.TwoLines }],
    },
  ];

  static getCommentsContent(item) {
    return (
      <GeneralEntryLogFigma
        description={CommentsEntryLogDescription}
        context={{ entityTypeId: 10007, entityId: item.FreelancerLineItemId }}
      />
    );
  }

  static getLogContent(item) {
    return (
      <LogComponent
        entityType='FreelancerLineItem'
        entityId={item.FreelancerLineItemId}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: FreelancerLineItem.getSelectedCellHeader,
        orderById: '',
        data: FreelancerLineItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'Id',
        orderById: 'FreelancerLineItemId',
        data: 'FreelancerLineItemId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 20,
      },
      {
        label: 'Vendor (ID)',
        orderById: 'FreelancerUserName',
        data: FreelancerLineItem.getFreelancerNameCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 40,
      },
      {
        label: 'Office',
        orderById: 'FreelancerUserOfficeName',
        data: 'FreelancerUserOfficeName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Client (Bravo ID)',
        orderById: 'ClientName',
        data: FreelancerLineItem.getClientName,
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Survey (ID)',
        orderById: 'SurveyName',
        data: FreelancerLineItem.getSurveyName,
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'TP Survey (ID)',
        orderById: 'TpSurveyId',
        data: 'TpSurveyThirdPartySurveyName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Third Party Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
      },
      {
        label: 'Application Month',
        orderById: 'ApplyDate',
        data: FreelancerLineItem.generateDateFieldContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 30,
      },
      {
        label: 'Fee',
        orderById: 'Fee',
        data: (item) => moneyHelper.toMoneyFormat(item.Fee, item.FreelancerUserCurrencyCode),
        type: FieldTypesEnum.PureDataField,
        minWidth: 40,
      },
      { label: 'Status', orderById: 'Status', data: 'Status', type: FieldTypesEnum.PureDataField },
      {
        label: 'Invoice ID',
        orderById: 'FreelancerInvoiceId',
        data: 'FreelancerInvoiceId',
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      {
        label: 'Additional Info',
        orderById: 'FeeType',
        data: FreelancerLineItem.getFeeTypeCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      {
        label: ' ',
        orderById: '',
        data: FreelancerLineItem.getMenuContent,
        type: FieldTypesEnum.ActionButton,
        minWidth: 20,
        rolekey: 'freelancerdatatable_action',
      },
    ];
  }

  static clickOnGlobalSelect(item, selected) {}

  static selectedStatus() {
    return false;
  }

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={FreelancerLineItem.selectedStatus()}
          onChange={(e) => {
            FreelancerLineItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static getSelectedCellContent(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            FreelancerLineItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnSelect(item, selected) {}

  static getFeeTypeCellContent(item) {
    return (
      <div
        className={
          item.FeeType === FeeTypesEnum.Resource
            ? 'text-success'
            : item.FeeType === FeeTypesEnum.DataQuality
            ? 'text-danger'
            : 'text-primary'
        }
      >
        <FaIcon
          iconName={FreelancerFeeHelper.GetFeeTypeIcon(item.FeeType)}
          tooltipText={item.FeeType}
        />{' '}
        {item.LineItemType === LineItemTypeEnum.Deduction ? (
          <FaIcon
            iconName='fa-solid fa-minus-square'
            className='text-danger'
            tooltipText='Deduction'
          />
        ) : (
          <FaIcon
            iconName='fa-solid fa-plus-square'
            tooltipText='Addition'
            className='text-success'
          />
        )}{' '}
        {item.TimesheetEntryId > 0 ? (
          <FaIcon
            iconName='fa-solid fa-history'
            className='Addition'
            tooltipText='Activity Tracker Entry'
          />
        ) : (
          ''
        )}
      </div>
    );
  }

  static getClientName(item) {
    return `${item.ClientName} (${item.ClientId})`;
  }

  static getSurveyName(item) {
    if (item.SurveySassieId === '' || item.SurveySassieId === undefined || item.SurveySassieId === null) return '';

    return `${item.SurveyName} (${item.SurveySassieId})`;
  }

  static getWaveName(item) {
    if (item.WaveSasseId === '' || item.WaveSasseId === undefined || item.WaveSasseId === null) return '';

    return `${item.WaveName} (${item.WaveSasseId})`;
  }

  static getTpSurveyName(item) {
    if (
      item.TpSurveyThirdPartySurveyId === '' ||
      item.TpSurveyThirdPartySurveyId === undefined ||
      item.TpSurveyThirdPartySurveyId === null
    )
      return '';
    return `${item.TpSurveyThirdPartySurveyName} (${item.TpSurveyThirdPartySurveyId})`;
  }

  static getTpWaveName(item) {
    if (
      item.TpWaveThirdPartyWaveIdId === '' ||
      item.TpWaveThirdPartyWaveIdId === undefined ||
      item.TpWaveThirdPartyWaveIdId === null
    )
      return '';
    return `${item.TpWaveThirdPartyWaveName} (${item.TpWaveThirdPartyWaveId})`;
  }

  static getFreelancerInvoiceIdCellContent(item) {
    if (!item.FreelancerInvoiceId) return null;
    return (
      <Link
        linktext={item.FreelancerInvoiceId}
        title='Invoices'
        link={<FreelancerInvoiceAdmin freelancerInvoiceId={item.FreelancerInvoiceId} />}
        className='link'
        iconName='fa-solid fa-file-invoice-dollar'
        url={`freelancer_invoices/search?FreelancerInvoiceId=${item.FreelancerInvoiceId}`}
      />
    );
  }

  static getMenuContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-redo',
            text: 'Repeat',
            disabled: item.LineItemType === LineItemTypeEnum.Deduction || item.TimesheetEntryId > 0,
            onClick: () => FreelancerLineItem.repeatLineItemFunction(item),
          },
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            onClick: () => FreelancerLineItem.editFunction(item.FreelancerLineItemId, item),
            disabled: item.FreelancerInvoiceId,
          },
          {
            title: 'VENDOR - INVOICES',
            text: 'Go to the invoice',
            link: <FreelancerInvoiceAdmin freelancerInvoiceId={item.FreelancerInvoiceId} />,
            iconName: 'fa-solid fa-file-invoice-dollar',
            disabled: !item.FreelancerInvoiceId,
          },
        ]}
      />
    );
  }

  static repeatLineItemFunction() {}

  static getLineItemTypeContent(item) {
    return (
      <div>
        {item.LineItemType === LineItemTypeEnum.Deduction ? (
          <FaIcon
            iconName='fa-solid fa-minus-square'
            className='text-danger'
            tooltipText='Deduction'
          />
        ) : (
          <FaIcon
            iconName='fa-solid fa-plus-square'
            tooltipText='Addition'
            className='text-success'
          />
        )}{' '}
        {item.LineItemType}
      </div>
    );
  }

  static getFreelancerNameCellContent(item) {
    return (
      <Link
        linktext={`${item.FreelancerUserName} (${item.FreelancerUserId})`}
        title='Vendors'
        link={<FreelancerUserAdmin freelancerUserId={item.FreelancerUserId} />}
        className='link'
        iconName='fa-solid fa-person-swimming'
        url={`freelancer/search?FreelanceUserId=${item.FreelancerUserId}&OfficeName=`}
      />
    );
  }

  static generateDateFieldContent(item) {
    return <span>{dateTimeHelper.toYYYYsMMsWithIndefiniteIcon(item.ApplyDate)}</span>;
  }

  static applyFeeForVendorFunction = (item) => {
    return null;
  };

  static copyLineItemCellContent(item) {
    return (
      <div
        className='link'
        onClick={() => FreelancerLineItem.copyLineItemFunction(item)}
      >
        <FaIcon iconName='fa-solid fa-pump-soap' /> Apply for Vendors
      </div>
    );
  }

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };

  static applyRules(item) {
    if (item.FeeType === FeeTypesEnum.DataQuality) {
      item.SelfAssigned = false;
      item.SurveyTypeCallsEmails = false;
    }
    if (item.FeeType === FeeTypesEnum.Resource) {
      item.OptFee = '';
    }

    return item;
  }

  static ifNANThenZero(num) {
    const conv = parseInt(num) > 0 ? parseInt(num) : 0;
    return isNaN(conv) ? 0 : conv;
  }

  static CorrectingTypes(item) {
    item.FreelancerLineItemId = item.FreelancerLineItemId = '' ? null : item.FreelancerLineItemId;
    item.FreelancerUserId = parseInt(item.FreelancerUserId);
    item.ClientId = parseInt(item.ClientId);
    item.SurveyId = parseInt(item.SurveyId);
    item.WaveId = parseInt(item.WaveId);
    item.TpSurveyId = parseInt(item.TpSurveyId);
    item.TpWaveId = parseInt(item.TpWaveId);
    item.ApplyDate = dateTimeHelper.toYYYYsMMsDD(item.ApplyDate);
    item.Fee = parseFloat(item.Fee);
    item.IsActive = booleanHelper.toBoolean(item.IsActive);
    return item;
  }
}

export default FreelancerLineItem;
